/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import _ from 'lodash';

import OptionsList from './itemsListFilter/OptionsList';
import FilterOptionsList from './itemsListFilter/FilterOptionsList';
import PriceFilterWrapper from './itemsListFilter/PriceFilterWrapper';
import RatingFilterWrapper from './itemsListFilter/RatingFilterWrapper';

class FilterAccordionFactory {
  constructor(onFilterCheckboxClicked, onPriceApplyClicked, onFilterRatingClicked) {
    this.onFilterCheckboxClicked = onFilterCheckboxClicked;
    this.onPriceApplyClicked = onPriceApplyClicked;
    this.onFilterRatingClicked = onFilterRatingClicked;
  }

  buildFilterGroups = filters => filters
    && _.cloneDeep(filters).map(
      filterOption => (filterOption.options.length <= 0 ? (
        null
      ) : ({
        title: filterOption.display_name,
        key: `${filterOption.name}-content`,
        content: {
          key: `${filterOption.name}-content`,
          content: this.renderFilter(filterOption.name, filterOption.options),
        },
      })),
    );

  renderFilter = (filterCategoryName, listOfOptions) => {
    if (filterCategoryName === 'brand_ids') {
      return (
        <FilterOptionsList
          filterCategoryName={filterCategoryName}
          listOfOptions={listOfOptions}
          onOptionClicked={this.onFilterCheckboxClicked}
        />
      );
    }

    if (filterCategoryName === 'price') {
      return (
        <PriceFilterWrapper listOfOptions={listOfOptions} onApplyClick={this.onPriceApplyClicked} />
      );
    }

    if (filterCategoryName === 'ratings') {
      return (
        <RatingFilterWrapper
          listOfOptions={listOfOptions}
          onSelectRating={this.onFilterRatingClicked}
        />
      );
    }

    return (
      <OptionsList
        filterCategoryName={filterCategoryName}
        listOfOptions={listOfOptions}
        onOptionClicked={this.onFilterCheckboxClicked}
      />
    );
  };
}

export default FilterAccordionFactory;
